// extracted by mini-css-extract-plugin
export default {"container":"FlagControl_container__h2UZr","value_container":"FlagControl_value_container__imYEc","description_container":"FlagControl_description_container__HleNt"};